export default __webpack_public_path__ + "static/media/Bracers of Vengeful Zeal.f609e784.jpg";